// extracted by mini-css-extract-plugin
module.exports = {"container":"More_container__3oX8J","content":"More_content__tqCG9"};